import http from "./http.service";
import Promisable from "./promisable.service";
import { getAppDispatch } from "utils/dispatch.util";
import { partnerActions } from "redux/slices/partner";
import { NavigateFunction } from "react-router-dom";
const url = "/events";

const EventService = {
  addEventRequest: async (data: any,navigate:NavigateFunction) => {
    const dispatch = getAppDispatch();
    dispatch?.(partnerActions.setLoading(true));
    http.setJWT();
    http.acceptLanguage();
    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}`, data)
    );
    if (success?.data?.data){
      navigate("/events")
    }
    dispatch?.(partnerActions.setLoading(false));
    return [success, error];
  },
};

export default EventService;
